/**
 * Ancillary Routes
 * legacy app: canActivate: [AuthGuard, VendorRoleGuard]
 */

import { lazy } from 'react';
import { RouteConfig, RouteMetadata } from '../../types';

const Labs = lazy(() => import('@src/apps/Labs/LabsConnected'));
const Imaging = lazy(() => import('@src/apps/Imaging/ImagingConnected'));

const EXTERNAL_ACCESS_DENIED: Pick<RouteMetadata, 'externalAccess'> = {
  externalAccess: false,
};

export const ancillaryRoutes: RouteConfig[] = [
  {
    path: 'ancillary/labs',
    component: Labs,
    guards: ['auth', 'vendor'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'Ancillary - Labs',
      breadcrumb: 'Labs',
      preload: false,
      delay: false,
    },
  },
  {
    path: 'ancillary/imaging',
    component: Imaging,
    guards: ['auth', 'vendor'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'Ancillary - Imaging',
      breadcrumb: 'Imaging',
      preload: false,
      delay: false,
    },
  },
];

